import { JsonObject, JsonProperty } from 'json2typescript';

import { ClientSignatureType, OrderClientInterface, OrderClientRelation, OrderClientStatus } from '../../../core';
import { ClientSignatureTypeAdapter } from '../../client/helpers/serializer/adapters/client-signature-type.adapter';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { OrderClientRelationAdapter } from '../../client/helpers/serializer/adapters/order-client-relation.adapter';
import { OrderClientStatusAdapter } from '../../client/helpers/serializer/adapters/order-client-status.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('OrderClient')
export class OrderClient implements OrderClientInterface {
    @JsonProperty('ListID', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('ClientID', IdAdapter, true)
    private _clientId: Id = undefined;

    @JsonProperty('ClientCode', IdAdapter, true)
    private _clientCode: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Surname', IdAdapter, true)
    private _surname: string = undefined;

    @JsonProperty('ParticipantType', OrderClientRelationAdapter, true)
    private _participantRelation: OrderClientRelation = undefined;

    @JsonProperty('LegalGuardianOf_Name', StringAdapter, true)
    private _legalGuardianOfName: string = undefined;

    @JsonProperty('LegalGuardianOf_Surname', StringAdapter, true)
    private _legalGuardianOfSurname: string = undefined;

    @JsonProperty('Phone', StringAdapter, true)
    private _phone: string = undefined;

    @JsonProperty('Email', StringAdapter, true)
    private _email: string = undefined;

    @JsonProperty('Signature_type', ClientSignatureTypeAdapter, true)
    private _signatureType: ClientSignatureType = undefined;

    private _isSoleHolder = false;

    @JsonProperty('Status', OrderClientStatusAdapter, true)
    private _status: OrderClientStatus = undefined;

    get id(): Id {
        return this._id;
    }

    get clientId(): Id {
        return this._clientId;
    }

    get clientCode(): Id {
        return this._clientCode;
    }

    get name(): string {
        return this._name;
    }

    get surname(): string {
        return this._surname;
    }

    get participantRelation(): OrderClientRelation {
        return this._participantRelation;
    }

    get legalGuardianOfName(): string {
        return this._legalGuardianOfName;
    }

    get legalGuardianOfSurname(): string {
        return this._legalGuardianOfSurname;
    }

    get phone(): string {
        return this._phone;
    }

    set phone(value: string) {
        this._phone = value;
    }

    get email(): string {
        return this._email ? this._email.toLowerCase() : this._email;
    }

    set email(value: string) {
        this._email = value;
    }

    get signatureType(): ClientSignatureType {
        return this._signatureType;
    }

    set signatureType(value: ClientSignatureType) {
        this._signatureType = value;
    }

    get isSoleHolder(): boolean {
        return this._isSoleHolder;
    }

    set isSoleHolder(value: boolean) {
        this._isSoleHolder = value;
    }

    get status(): OrderClientStatus {
        return this._status;
    }
}
